

export enum HeadlineTypeEnum {
  PANEL = "panel",
  FINANCE = "finance",
  CLIENTS = "clients",
  COMPANIES = "companies",
  PROJECTS = "projects",
  SETTINGS = "settings",
  TASKS = "tasks",
  SELLING = "selling"
}

export type HeadlineType = (typeof HeadlineTypeEnum)[keyof typeof HeadlineTypeEnum];
